import React from 'react'
import { defaultSortOptions } from '../../utils'
import PaginationInfo from './list-filter-pagination-info'
import Sorter from './list-filter-sorter'

const ListFilterHeader = ({pageIndexes, totalData, sortOptions, onSort, query}) => {
  const currentPageStart = pageIndexes[0]+1
  const currentPageEnd = pageIndexes[1]
  const finalCurrentPageEnd = currentPageEnd > totalData ? totalData : currentPageEnd

  const getSortOptions = (postTypeSortOptions) => {
    if(postTypeSortOptions){
      const options = postTypeSortOptions
      return defaultSortOptions.filter(a => options.includes(a.key))
    }

    return defaultSortOptions
  }

  const handleSort = (selectedSorter) => {
    if(typeof onSort === 'function'){
      onSort(selectedSorter)
    }
  }

  return <>
    <div className="justify-between mb-8 text-sm flex">
      <PaginationInfo
        currentPageStart={currentPageStart}
        currentPageEnd={finalCurrentPageEnd}
        totalData={totalData}
      />
      <Sorter
        query={query}
        onChange={handleSort}
        options={getSortOptions(sortOptions)}
      />
    </div>
  </>
}

export default ListFilterHeader
